<!--  -->
<template>
    <div class="wrapper">
        <!-- <div class="title">社保人申请状态</div> -->
        <Title text="近一个月部门受理、办结对比" />
        <div class="main">
            <div class="lw">
                <div class="legend">
                    <div class="c">
                        <span class="blue"></span>
                        <span>受理</span>
                    </div>
                    <div class="c">
                        <span class="green"></span>
                        <span>办结</span>
                    </div>
                </div>
            </div>

            <div class="itemwrapper">
                <div
                    v-for="(itemx, index) in list"
                    :key="`cheifage_${index}`"
                    class="row"
                >
                    <div
                        class="item"
                        v-for="(item, i) in itemx.dataArr"
                        :key="`c_${i}`"
                    >
                        <div class="x"></div>
                        <div
                            class="itemTitle"
                            :style="'color:' + color[item.mark]"
                        >
                            {{ item.count }}件
                        </div>
                        <div
                            class="cylinder"
                            :style="
                                'marginBottom:' +
                                (item.stylePercent * 2) / 3 +
                                'px'
                            "
                        >
                            <div
                                class="ellipse"
                                :style="'background:' + color[item.mark]"
                            ></div>
                            <div
                                class="rectangle"
                                :style="
                                    'height:' +
                                    (2 * item.stylePercent + 30) +
                                    'px;' +
                                    'background:' +
                                    colors[item.mark]
                                "
                            ></div>
                        </div>

                        <!-- <div class="itemLabel" :style="'color:' + color[item.mark]">
                            {{item.type}}
                        </div> -->
                    </div>
                    <div class="dw">{{ itemx.name }}</div>
                </div>

                <div class="line"></div>
            </div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Title from "./components/title";

export default {
    //import引入的组件需要注入到对象中才能使用
    components: { Title },
    data() {
        //这里存放数据
        return {
            list: [],
            color: ["rgba(0, 160, 233, 1)", "rgba(0, 251, 202, 1)"],
            colors: [
                "linear-gradient(90deg, #0084FF 0%, rgba(0, 127, 246, 0.2) 63%, #017CF1 100%)",
                "linear-gradient(90deg, #00FFCC 0%, rgba(0, 255, 204, 0.2) 63%, #00FFCC 100%)",
            ],
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getToken() {
            let formData = new FormData();
            formData.append("username", "dongxiang");
            formData.append("password", "dxq!@123456@!");
            this.$post(this.urlobj.dx_dl, formData).then((res) => {
                localStorage.token = res.newPrimaryKeys.token;
                this.$store.commit("updateToken", res.newPrimaryKeys.token);
                this.getData();
            });
        },
        getData() {
            var url = this.urlobj.dx_bmsl + "?type=dxbmbltj";
            this.$get(url).then((res) => {
                let all = 0;
                let max = 0;
                let data = res.rows[0].data;
                data.forEach((item) => {
                    if (max < item.count) max = item.count - 0;
                    all += item.count - 0;
                });
                console.log(max, all);
                data.map((itemx) => {
                    itemx.dataArr = itemx.dataArr.map((item) => {
                        return {
                            ...item,
                            mark: item.type == "受理" ? 0 : 1,
                            stylePercent: ((item.count - 0 / max) / 2).toFixed(
                                2
                            ),
                            percent: ((item.count - 0 / all) / 2).toFixed(2),
                            label:
                                ((item.count - 0 / all) / 2).toFixed(2) +
                                "%\n" +
                                item.count -
                                0 +
                                "人",
                        };
                    });

                    return itemx;
                });

                this.list = data.slice(0, 8);

                console.log(this.list);
            });
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {},

    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        if(this.$store.state.access_token){
            this.getData();
        }else{
            this.getToken();
        }
        
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.wrapper {
    height: 660px;
}
.main {
    margin: 50px 0;
    padding: 80px 0 0 0;
    height: 740px;
}

.colorName {
    color: black;
}
.item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 640px;
    margin: 0 10px;
    overflow: hidden;
}
.cylinder {
    transform: rotateX(70deg);
    margin: 0 auto;
}

.ellipse {
    --bkc: red;
    width: 30px;
    height: 30px;
    // background: #00A0E9;
    background: var(--bkc);
    border-radius: 15px;
}

.rectangle {
    width: 30px;
    height: 200px;
    max-height: 1753px;
    position: absolute;
    background: linear-gradient(
        90deg,
        #0084ff 0%,
        rgba(0, 127, 246, 0.2) 63%,
        #017cf1 100%
    );
    top: 0;
    left: 0;
    border-radius: 15px;
    z-index: -1;
}
.x {
    height: 400px;
}
.itemTitle {
    font-size: 14px;
    color: #27bbff;
    display: flex;
    justify-content: center;
    align-items: center;
}
.itemLabel {
    font-size: 14px;
    color: #fff;
    text-align: center;
}
.itemwrapper {
    width: 100%;
    display: flex;
    justify-content: space-around;
    margin: 40px 0 0 0;
}
.line {
    width: 96%;
    position: absolute;
    bottom: 45px;
    left: 30px;
    border-top: 1px solid rgba(255, 255, 255, 0.5);
}
.row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    .dw {
        position: absolute;
        bottom: -42px;
        left: -45px;
        width: 200px;
        font-size: 16px;
        text-align: center;
    }
}
.lw {
    display: flex;
    justify-content: center;
    margin: 0 0 20px 0;
}
.legend {
    display: flex;
    align-items: center;
    justify-content: space-around;
    div {
        text-align: center;
        width: 150px;
        :nth-child(1) {
            width: 24px;
            height: 16px;
            border-radius: 4px;
            margin-right: 6px;
        }
    }
    span {
        display: inline-block;
        font-size: 18px;
    }

    .blue {
        background: #00a0e9;
    }
    .green {
        background: #00fbca;
    }
}
</style>